export function addDaysToDate(dateString: string, days: number): string {
  const date = new Date(new Date(dateString).toISOString().split("T")[0]);

  date.setDate(date.getDate() + days);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}/${month}/${day}`;

  return formattedDate;
}

export function isCurrentTimeBetween(startTimestamp, endTimestamp) {
  const now = new Date();
  const nowLocalISOString = new Date(
    now.getTime() - now.getTimezoneOffset() * 60000
  ).toISOString();

  return (
    nowLocalISOString >= startTimestamp && nowLocalISOString <= endTimestamp
  );
}
